
import { FormControl, FormGroup } from "@angular/forms";
import { Control, ControlInlined } from "../../business-objects/control/control.model";
import { ControlType } from "../../business-objects/control-type/control-type.model";
export class FormHelper {

    static findFormControl(name: string, formGroup: FormGroup): FormControl {

        let found: any = false;

        Object.keys(formGroup.controls).forEach(key => {

            if (found !== false) {
                return;
            }

            if (key === name) {
                found = formGroup.controls[key];
                return;
            }

            if (formGroup.controls[key] instanceof FormGroup) {
                found = FormHelper.findFormControl(name, formGroup.controls[key] as FormGroup);
            }
        });

        return found;
    }

    static getControlTypeName(control: Control, possibleTypes: Array<ControlType>): string {
        if (!possibleTypes) {
            console.warn("possibleTypes are missing!");
            return;
        }

        var controlTypeId = control.controlType;
        if (control instanceof ControlInlined) {
            controlTypeId = control.controlType.id;
        }

        const controlType: ControlType = possibleTypes.find(ct => ct.id === controlTypeId);

        if (!controlType) {
            return control.controlType;
        }

        return controlType.name;
    }
}



// WEBPACK FOOTER //
// ./src/vas/pages/form/form-helper.ts